import React from 'react';
import { useSelector } from 'react-redux';
import { selectAuthStatus } from 'reducers/auth';
import { NavBar } from 'components/pageComponents/navBar/NavBar';
import { Footer } from 'components/pageComponents/footer/Footer';
import { PublicModal } from 'components/publicModal/PublicModal';
import { SignInForm } from 'components/pages/signIn/SignInForm';
import { SignUpForm } from 'components/pages/signUp/SignUpForm';

const PrivateLoginRouter: React.FC = ({ children }) => {
    const authStatus = useSelector(selectAuthStatus);
    const [signInFormState, setSignInFormState] = React.useState<'SIGN_IN' | 'SIGN_UP'>('SIGN_IN');


    if (authStatus === 'signed_out') {
        return <>
            <NavBar isThemed={false} />
            <PublicModal
                handleClose={() => { console.log('close modal'); }}
                className="FormModal"
            >
                {signInFormState === 'SIGN_IN' ? (
                    <SignInForm
                        noRedirect
                        switchToSignUp={() => setSignInFormState('SIGN_UP')}
                    />
                ) : (
                    <SignUpForm
                        switchToSignIn={() => setSignInFormState('SIGN_IN')}
                    />
                )}
            </PublicModal>
            <Footer isThemed={false} />
        </>
    }

    return <React.Fragment>{children}</React.Fragment>;
};

export default PrivateLoginRouter;
